<template>
  <div class="kpi cx-card-height">
    <head-text  :kpi="Primary" 
                :isSmall="isSmall"
                :fallbackText="fallbackText">
    </head-text>

    <item :thresholdData="thresholdData" 
          :round="true" 
          :isSmall="isSmall"
          :kpi="Primary">
    </item>

    <spacer :size="getSpacerSize()" />

    <cup :show="showBowl && hasSecondary"  />
    <spacer v-if="!showBowl" :size="4" />

    <head-text  v-if="hasSecondary" 
                :kpi="Secondary" 
                :isSmall="isSmall"
                :isSecondary="true">
    </head-text>

    <item v-if="hasSecondary" 
          :thresholdData="thresholdDataSecondary ?? thresholdData" 
          :round="true" 
          :isSmall="isSmall"
          :kpi="Secondary">
    </item>

    <div v-if="hasSecondary && secondaryKpiItems">
      <div  class=" mx-1 px-1 py-2" 
            :style="{ 'height': overlap ? '17rem' : '22rem' }"
            style="overflow-x: hidden;"> 
        <div v-for="item in secondaryKpiItems" :key="item.Code">
          <head-text  :kpi="item" 
                      :isSmall="isSmall"
                      :isSecondary="true">
          </head-text>
          <item :thresholdData="thresholdDataSecondary ?? thresholdData" 
                :round="true" 
                :isSmall="isSmall"
                :kpi="item">
          </item>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cup from './KpiCup.vue';
import HeadText from './KpiHeader.vue';
import Item from './KpiItem.vue';
import Spacer from './KpiSpacer.vue';

export default {
  props: {
    actualTimeSetting: String,
    fallbackText: String,
    primaryKpi: Object,
    primaryKpiYTD: Object,
    secondaryKpi: Object,
    secondaryKpiYTD: Object,
    secondaryKpiItems: { type: Array, required: false, default: undefined },
    secondaryKpiItemsYTD: { type: Array, required: false, default: undefined },
    showBowl: Boolean,
    thresholdData: Array,
    thresholdDataSecondary: Array,
    isSmall: { type: Boolean, default: false },
    overlap: { type: Boolean, default: false },
  },

  components: {
    HeadText, Spacer, Cup, Item
  },

  methods: {
    getSpacerSize() {
      return this.isSmall ? (this.overlap ? 6.65 : 1.65) : 7;
    }
  },
   
  computed: {
    
    hasPrimary() {
      return this.actualTimeSetting == 'current'
        ? this.primaryKpi !== undefined
        : this.primaryKpiYTD !== undefined;
    },
    hasSecondary() {
      return this.actualTimeSetting == 'current'
        ? this.secondaryKpi !== undefined
        : this.secondaryKpiYTD !== undefined;
    },
    Primary() {
      return this.actualTimeSetting == 'current'
        ? this.primaryKpi
        : this.primaryKpiYTD;
    },
    Secondary() {
      return this.actualTimeSetting == 'current'
        ? this.secondaryKpi
        : this.secondaryKpiYTD;
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";
</style>
